import { INSPECTOR_MAGNETIC_SWITCH } from "../../../constants/inspectorConstants";
import Symbol from "./Symbol";

class MagneticSwitch extends Symbol {
    constructor({ alias, svgSrc, label, rotable}) {
        super("MagneticSwitch", { alias, svgSrc, label, rotable });

        this.rotable = rotable;
    }

    getInspector() {
        return INSPECTOR_MAGNETIC_SWITCH;
    }
}

export default MagneticSwitch;
